
import { initHeaderFunctions } from './modules/header.js';
import { initTopFunctions } from './modules/top.js';
import { initBreadcrumbFunctions } from './modules/breadcrumb.js';
import { initFooterFunctions } from './modules/footer.js';
import { initCommonFunctions } from './modules/common.js';
import { initTemplateBFunctions } from './modules/templateB.js';
import { initCalendarFunctions } from './modules/calendar.js';
import { initfaqFunctions } from './modules/faq.js';
import { initAccordionFunctions } from './modules/accordion.js';
import { initEventsFunctions } from './modules/events.js';
import { initCourseFunction } from './modules/course.js';
import { initSliderFunctions } from "./modules/slider.js"
import { initRealWeddingFunctions } from './modules/realWedding.js';
import { initFacilitiesFunction } from './modules/facilities.js';
import { initWeddingApplicationFunction } from './modules/weddingApplication.js';


initHeaderFunctions();
initTopFunctions();
initBreadcrumbFunctions();
initFooterFunctions();
initCommonFunctions();
initTemplateBFunctions();
initCourseFunction();
initSliderFunctions();
initRealWeddingFunctions()
initFacilitiesFunction()
initWeddingApplicationFunction()
initCalendarFunctions();
initfaqFunctions();
initAccordionFunctions();
initEventsFunctions();